import { AdSlotsRepository } from './ad-slots-repository'
import Logger from './logger'

/**
 * 入札による広告配信のコアクラス。
 */
export default class HeaderBiddingAdService {
    private readonly slots: AdSlotsRepository

    constructor(
        private readonly adService: AdService,
        private readonly bidderService: BidderService,
        slots: SlotDefinition[],
        private readonly observerFactory: LazyLoadObserverFactory,
    ) {
        slots.forEach(slot => this.bidderService.addSlot(slot))
        this.slots = new AdSlotsRepository(slots)
    }

    /**
     * 初期表示広告枠の入札を開始する。
     */
    public requestInitialBids(callback: Command) {
        const initialSlots = this.slots.getInitialLoadSlots()
        if (initialSlots.length < 1) {
            Logger.warn('初期表示広告枠が定義されていないため、初期表示広告の入札は行いません')
            callback()
            return
        }
        Logger.debug('初期表示広告枠の入札を開始します')
        Logger.time('初期表示広告枠の入札')
        this.bidderService.requestBids(initialSlots, () => {
            Logger.timeEnd('初期表示広告枠の入札')
            Logger.debug('初期表示広告枠の入札が完了しました')
            callback()
        })
    }

    /**
     * 入札が完了した初期表示広告枠に広告を配信する。
     */
    public deliveryInitialAds() {
        const initialSlots = this.slots.getInitialLoadSlots()
        if (initialSlots.length < 1) {
            Logger.warn('初期表示広告枠が定義されていないため、初期表示広告の配信は行いません')
            return
        }
        this.bidderService.preRenderAds(initialSlots)
        this.adService.deliverAds(initialSlots)
        Logger.debug('初期表示広告枠の広告配信が完了しました')
    }

    /**
     * 遅延表示広告枠がある場合はそれらに対して監視を開始する。
     */
    public observeLazyLoadSlots() {
        const lazyLoadSlots = this.slots.getLazyLoadSlots()
        if (lazyLoadSlots.length < 1) {
            Logger.info('遅延表示広告枠が定義されていないため、遅延表示広告枠の監視は行いません')
            return
        }
        Logger.debug('遅延表示広告枠の監視を開始します')
        lazyLoadSlots.forEach(slot => this.observeLazySlot(slot))
    }

    private observeLazySlot(lazyLoadSlot: SlotDefinition) {
        // 監視オブジェクトは必要になってから生成する
        const observer = this.observerFactory.create()
        observer.observe(lazyLoadSlot, slot => {
            if (slot === null) return
            Logger.debug(`遅延表示広告 ${slot.id} の入札を開始します`)
            this.bidderService.requestBids([slot], () => {
                this.bidderService.preRenderAds([slot])
                this.adService.deliverAds([slot])
                Logger.debug(`遅延表示広告 ${slot.id} を配信しました`)
            })
        })
    }
}
